import { DEFAULT_BRANDING } from '@repo/utils';

import { useFetchTenantInfo } from './useFetchTenantInfo';

export interface ResolvedBranding {
  logo: string;
  logoDark: string;
  logoSmall: string;
  logoSmallDark: string;
  faviconUrl?: string;
  productName: string;
  companyName: string;
}

export const useBranding = (): ResolvedBranding => {
  const { tenantInfoData } = useFetchTenantInfo();

  return {
    logo: tenantInfoData?.logoUrl ?? DEFAULT_BRANDING.logo,
    logoDark: tenantInfoData?.logoDarkUrl ?? DEFAULT_BRANDING.logoDark,
    logoSmall: tenantInfoData?.logoSmallUrl ?? DEFAULT_BRANDING.logoSmall,
    logoSmallDark: tenantInfoData?.logoSmallDarkUrl ?? DEFAULT_BRANDING.logoSmallDark,
    faviconUrl: tenantInfoData?.faviconUrl,
    productName: tenantInfoData?.productName ?? DEFAULT_BRANDING.productName,
    companyName: tenantInfoData?.companyName ?? DEFAULT_BRANDING.companyName,
  };
};
